import {useIsFocused} from '@react-navigation/native';
import React, {useEffect, useState} from 'react';
import {FlatList} from 'react-native';
import {format, parseISO} from 'date-fns';

import {Header} from '../../../components/Interface/Headers/Header';
import {PaymentItem} from '../../../components/shared/Payments/PaymentItem';
import {Loading} from '../../../components/Interface/Loadings/Loading';

import {api} from '../../../services/api';

import {PaymentDTO} from '../../../dtos/PaymentDTO';

import {Container, Content} from './styles';
import {RFValue} from 'react-native-responsive-fontsize';
import {Titles} from '../../../components/Interface/Typographies/Titles';
import {NotFound} from '../../../components/Interface/Search/NotFound';
import {getStatusBarHeight} from 'react-native-iphone-screen-helper';

interface Data {
  id: string;
  name: string;
  value: number;
  paid: boolean;
  paymentMethod: string;
  installments: number;
  pixCopiaECola: string;
  created_at: {
    date: string;
    time: string;
  };
  updated_at: Date;
}

export function PaymentsHistory() {
  const isFocused = useIsFocused();

  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    let isMounted = true;

    async function fetchPayments() {
      setIsLoading(true);
      setIsError(false);
      try {
        await api
          .get('/ordersHistory')
          .then(response => {
            const formatted = response.data.map((data: PaymentDTO) => {
              const date = format(parseISO(data.created_at), 'dd/MM/yyyy');
              const time = format(parseISO(data.created_at), 'HH:mm');

              return {
                id: data.id,
                name: data.name,
                value: data.totalValue,
                paid: data.paid,
                paymentMethod: data.paymentMethod,
                installments: data.installment,
                pixCopiaECola: data.pixCopiaECola,
                created_at: {
                  date,
                  time,
                },
                updated_at: data.created_at,
              };
            });
            if (isMounted) {
              const sortByDate = formatted.sort(function (a: Data, b: Data) {
                return (
                  new Date(b.updated_at).valueOf() -
                  new Date(a.updated_at).valueOf()
                );
              });

              const paidPayments = sortByDate.filter((item: Data) => item.paid);

              setData(paidPayments);
            }
          })
          .catch(() => {
            if (isMounted) {
              setIsError(true);
            }
          });
      } catch (error) {
        console.log(error);
      } finally {
        if (isMounted) {
          setIsLoading(false);
          isMounted = false;
        }
      }
    }

    fetchPayments();

    return () => {
      isMounted = false;
    };
  }, [isFocused]);

  return (
    <Container>
      {isLoading && <Loading />}
      <Header icon="chevron-left" />

      <Content>
        {isError && (
          <NotFound
            style={{
              marginTop: -getStatusBarHeight(),
            }}
            title="Ocorreu um problema"
            text="Não conseguimos listar seu histórico de pagamentos."
          />
        )}

        {data.length !== 0
          ? !isError && (
              <>
                <Titles title="Extrato" />
                <FlatList
                  data={data}
                  keyExtractor={(e: any) => e.id}
                  style={{
                    marginHorizontal: -24,
                  }}
                  renderItem={({item}) => <PaymentItem data={item} />}
                  showsVerticalScrollIndicator={false}
                  contentContainerStyle={{
                    paddingBottom: RFValue(20),
                  }}
                />
              </>
            )
          : !isLoading &&
            !isError && (
              <NotFound
                style={{
                  marginTop: -getStatusBarHeight(),
                }}
                title="Nenhuma compra realizada"
                text="Realize ao menos uma compra para exibir o histórico."
              />
            )}
      </Content>
    </Container>
  );
}
